import React from "react";
import Snippet from "../SnippetIcon/Snippet";
import InlineError from "../InlineError/InlineError";
import {
  FIELD_DEFAULT,
  FIELD_DEFAULT_VARIANT,
  INPUT_FIELD_VARIANT_CLASSES,
  resolveFieldVariant,
} from "./fieldSystem";

/**
 * Resolves single-line input classes from Field System presets.
 * Variants: default/large/general/medium → Default; full → 100% parent width;
 * inline96–inline240 → Inline; search, upload, …
 */
const resolveTextFieldClass = (variant, fullWidth = false) => {
  const key = resolveFieldVariant(variant, fullWidth);
  return (
    INPUT_FIELD_VARIANT_CLASSES[key] ??
    INPUT_FIELD_VARIANT_CLASSES[FIELD_DEFAULT_VARIANT.text] ??
    FIELD_DEFAULT
  );
};

const TextFiled = ({
  className = "",
  fieldClassName,
  label,
  placeholder,
  variant = FIELD_DEFAULT_VARIANT.text,
  fullWidth = false,
  snippet,
  SnippetText,
  star,
  error,
  inputRef,
  ...restProps
}) => {
  const preset = fieldClassName ?? resolveTextFieldClass(variant, fullWidth);
  const merged = `${preset} ${className}`.trim();

  return (
    <div className="flex w-full min-w-0 flex-col">
      {(label || SnippetText || snippet || star) && (
        <Snippet
          variant={"label"}
          label={label}
          text={SnippetText}
          snippet={snippet}
          star={star}
        />
      )}
      <input
        ref={inputRef}
        {...restProps}
        name={restProps?.name}
        placeholder={placeholder}
        className={merged}
      />
      <InlineError message={error} />
    </div>
  );
};

export default TextFiled;
